import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import MaterialSubcategoryTableFilters from "components/subComponents/MaterialSubcategoryTableFilters";

import useMaterialSubcategoryList from "hooks/list/useMaterialSubcategoryList";

function ElencoSottoCatMateriali() {
    const materialSubcategoryListHook = useMaterialSubcategoryList();

    const { navigateToNewMaterialSubcategory, alertConfirmHook, dataTableHook } =
        materialSubcategoryListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <MaterialSubcategoryTableFilters
                    materialSubcategoryListHook={materialSubcategoryListHook}
                />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewMaterialSubcategory}>
                        Nuova Sottocategoria
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoSottoCatMateriali;
